module.exports = __webpack_public_path__ + "static/img/身份认证.8eb2d66b.png";